var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPtAssistanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 101,
    viewBox: "0 0 90 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_526_402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 91,
    height: 102
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0068 -0.00598145H0.000732422V100.401H90.0068V-0.00598145Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_526_402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0954 0C35.8454 0 46.1955 10.34 46.1955 23.09C46.1955 35.84 35.8454 46.1901 23.0954 46.1901C10.3554 46.1901 0.000366211 35.84 0.000366211 23.09C0.000366211 10.34 10.3554 0 23.0954 0ZM26.2954 20.8201C26.2954 19.9401 25.5754 19.23 24.6954 19.23H21.5054C19.8054 19.2 17.8254 19.7 18.0054 20.37C18.1154 20.74 19.9854 22.3401 19.9854 22.8101C19.9854 25.2501 19.9054 35.48 19.9054 35.48C19.9054 36.36 20.6154 37.08 21.5054 37.08H24.6954C25.3254 37.08 27.1955 37.06 28.3355 37.04C28.5155 37.04 30.0054 37.05 30.1454 37.05C30.2854 37.05 30.0654 36.52 30.0154 36.48C28.6254 35.44 27.2254 34.8 26.6554 34.12C26.3954 33.8 26.3055 32.64 26.3055 32.64L26.2954 20.8201ZM23.0954 8.52002C20.9754 8.52002 19.2554 10.25 19.2554 12.37C19.2554 14.49 20.9754 16.22 23.0954 16.22C25.2154 16.22 26.9455 14.49 26.9455 12.37C26.9455 10.25 25.2154 8.52002 23.0954 8.52002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5695 28.64C45.0495 33.4211 47.2196 33.7074 50.7296 38.1855C53.5396 41.7714 36.8696 38.9598 36.7696 38.9093C34.8496 38.0171 33.4095 37.2596 32.5595 36.2832C28.8495 31.9734 46.0595 24.0777 45.5695 28.64Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4906 48.3003C63.5764 48.3003 57.9704 53.906 57.9704 60.821V97.9803C57.9704 98.6224 58.2257 99.2386 58.6796 99.6923C59.1336 100.147 59.7496 100.401 60.3919 100.401C66.3454 100.401 81.6441 100.401 87.591 100.401C88.9256 100.401 90.0068 99.3203 90.0068 97.986C90.0068 91.7066 90.0068 74.4956 90.0068 62.0898C90.0068 58.433 88.5545 54.9257 85.9681 52.3396C83.3818 49.7535 79.8743 48.3003 76.2171 48.3003C74.3145 48.3003 72.3686 48.3003 70.4906 48.3003Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9463 42.6851C65.7046 42.6851 60.6448 37.5652 60.6448 31.2494C60.6448 24.9336 65.7046 19.8136 71.9463 19.8136C78.1879 19.8136 83.2478 24.9336 83.2478 31.2494C83.2478 37.5652 78.1879 42.6851 71.9463 42.6851Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtAssistanceIcon);
export default __webpack_public_path__ + "static/media/PT_assistance_icon.373553b90a89e3b376265d627e0c730c.svg";
export { ForwardRef as ReactComponent };